import { toPlainText } from "../../../sanity/helpers/sanitySchemaHelpers";

export function buildImageObj(source) {
  return {
    asset: {
      _ref: source.asset && (source.asset._ref || source.asset._id),
    },
    // Doesn't add these props if they are empty
    ...(source.crop && { crop: source.crop }),
    ...(source.hotspot && { hotspot: source.hotspot }),
  };
}

export const getBlockImage = content => {
  return content?.map(obj => {
    return obj?.textContent?.filter(
      blockObj => blockObj?._type === "articleImage"
    );
  })?.[0]?.[0];
};

export const getBlockContent = content => {
  return (
    content?.find(obj => obj?.textContent) &&
    toPlainText(content?.find(obj => obj?.textContent)?.textContent)?.substr(
      0,
      200
    )
  );
};

export const setWithExpiry = (key, value, ttl = 600000) => {
  if (typeof window !== "undefined") {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
};

export const getWithExpiry = key => {
  if (typeof window !== "undefined") {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
};
